<template>
    <div class="container-fluid">

        <div class="row">

       <div class="col-auto d-lg-block d-none sidebar-bg-color">

              <div class="text-white ">

                <div class="row justify-content-center mt-2">

                <div :class="ShowBar?'col-md-6':'col-12'">

                    <img src="https://ugcollege.ge/public//assets/images/logo-white.svg" alt="">
         

                  </div> 

                </div>

                <div class="d-flex text-white mt-3">

                 <span><img src="../assets/images/download.jpg" class="img-fluid rounded-circle mt-2" alt=""></span>

                  
                 <span class="d-md-block d-none" v-if="ShowBar"> <p class="ms-2 mt-4">{{this.$store.state.user.fname}} {{ this.$store.state.user.lname }}</p></span>

                 
                 
                 
                </div>
 
                  <router-link :to="menu.menus.href" class="text-decoration-none text-white" v-if="this.$store.state.user.user_menus.length>0" v-for="menu of this.$store.state.user.user_menus">

                      <div class="row g-0  mt-2 p-3"> 

                          <div class="col-12 col-md-1" v-html="menu.menus.icon"></div> 

                          <div class=" col-md-11 d-md-block d-none  px-2" v-if="ShowBar">{{ menu.menus.menu_name }}</div> 

                    </div>
                     </router-link> 
                        
                    

                      
                    
                         
                      
           </div>

          </div> 
 
      <div class="col h-100px h-100px-bg">
            <div class="row">
            <div class="col-1">
            <i class='bx bx-menu cursor-pointer fs-3 mt-3 text-white icon-menu' @click='ShowleftHide()' v-if="menuburger"></i>
           </div>
                   <div class="col-11 mt-2">
                        <!-- <form class="d-flex" role="search">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success text-white" type="submit">Search</button>
      </form> -->

      <button type="button"   @click="logOut()" class="btn btn-outline-success text-white d-block ms-auto "><i class='bx bxs-log-in-circle  fs-3 mt-1'></i></button>

                  </div>  
                     
    </div>
    
              <div class="row ">
     
                   

          <router-view/>
            


              </div>

          </div> 

        </div>

    </div>
 
</template>

 <script>
import HttpRequests from '../httpRequests/httpRequests';
const httpRequests = new HttpRequests()
export default{
 data() {
   return{
     ShowBar:true,
     width:'',
     menuburger:true

   } 
  },
  created(){
    window.addEventListener('resize',()=>{
          this.width=document.documentElement.clientWidth
          if(this.width<=704){
            this.ShowBar=false
           this.menuburger=false
          }else{
              this.ShowBar=true
              this.menuburger=true

          }
          

    })

  },
methods:{
    ShowleftHide(){
     
      this.ShowBar=!this.ShowBar 
    },
    logOut(){

      httpRequests.logOut().then(()=>{
            localStorage.removeItem('token')
            window.location.href='/'
      })

    }
  

}

}
</script>


